/**
 * このファイルにパスの定義を集約する
 */

/**
 * 業務選択画面へのパス
 */
export const pathToSelectionWork = () => "/SelectionWork";

/**
 * ビル一覧画面へのパス
 */
export const pathToBuildingList = () => "/building/:buildingName";

/**
 * 清掃結果確認画面へのパス
 */
export const pathToCleaningEvent = () => "/CleaningEvent";

/**
 * ロボット詳細画面へのパス
 */
export const pathToRobotDetail = (robotId: string) =>
  `/RobotDetail?id=${robotId}`;

/**
 * Route用。navigateのパスには使用しないでください。
 */
export const baseRobotDetailPath = () => "/RobotDetail";

/**
 * 清掃ログへのパス
 */
export const pathToCleaningLog = (robotId: string) =>
  `${baseCleaningLogPath()}?id=${robotId}`;

/**
 * Route用。navigateのパスには使用しないでください。
 */
export const baseCleaningLogPath = () => "/CleaningLog";

/**
 * 次回清掃予定画面へのパス
 */
export const pathToSchedule = () => "/ScheduleList";

/**
 * ロボット一覧画面へのパス
 */
export const pathToRobotStatus = () => "/RobotStatus";

/**
 * マップ一覧画面へのパス
 */
export const pathToMapSchedule = () => "/MapSchedule";

/**
 * マップ詳細画面へのパス
 */
export const pathToMapDetail = (mapId: string) =>
  `${baseMapDetailPath()}?mapId=${mapId}`;

/**
 * Route用。navigateのパスには使用しないでください。
 */
export const baseMapDetailPath = () => "/MapDetail";

/**
 * マップ清掃ログページへのパス
 */
export const pathToMapCleaningLog = (mapId: string) =>
  `/MapCleaningLog?mapId=${mapId}`;

/**
 * Route用。navigateのパスには使用しないでください。
 */
export const baseMapCleaningLogPath = () => `/MapCleaningLog`;

/**
 * タイマー設定(ロボット清掃スケジュール)ページへのパス
 */
export const pathToCleaningSchedule = (robotId: string) =>
  `${baseCleaningSchedule()}?id=${robotId}`;

/**
 * Route用。navigateのパスには使用しないでください。
 */
export const baseCleaningSchedule = () => "/CleaningSchedule";

/**
 * エラー通知画面へのパス
 */
export const pathToErrorNotifications = () => "/ErrorNotifications";

export const pathToRegistration = () => "/Registration";

export const pathToLogin = () => "/Login";

export const pathToSignup = () => "/Signup";

export const pathToVerifyCode = () => "/VerifyCode";

export const pathToSetting = () => "/Setting";
